import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSimpleStepItem from "../../components/simple-steps/FormAddEditSimpleStepItem";
import { useGetSimpleStepItem } from "../../hooks/simple-steps/useGetSimpleStepItem";
import LoadingPage from "../../components/global/LoadingPage";

const EditSimpleStepItem = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, item } = useGetSimpleStepItem(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/simple-steps");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSimpleStepItem
                isEdit={true}
                currentData={item}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditSimpleStepItem;
